import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableColumn } from '@ui/aos-lib';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
  template: ` {{ translatedValue() | translate }} `
})
export class TextTranslateColumnComponent {
  item = input.required<{ [key: string]: string }>();
  column = input.required<TableColumn>();

  protected value = computed(() => this.item()[this.column().field]);
  protected translatedValue = computed(
    () => translationKeysMap.get(this.value()) || this.item()[this.column().field] || ''
  );
}
